import axios from "axios";
import { CorporateUserRegisterData, 
  createCorporateUserRequest, 
  createCorporateProjectRequest, 
  updateCorporateProjectRequest, 
  CreatePaymentInformationCorporateRequest,
  Project,
  billingStatementResponse
 } from "./dto/Corporation";

import { EmployeeDealsResponse } from "@/api/dto/Deal"

  

export const getCorporateUserRegisterData = async (id: string): Promise<CorporateUserRegisterData> => {
    const res = await axios.get<CorporateUserRegisterData>(`/api/corporation/user/registerData?id=${id}`, {
      headers: { "Content-Type": "application/json;charset=utf-8" },
    });
    return res.data;
};

export const createCorporateUser = async (
  req: createCorporateUserRequest
): Promise<void> => {
  await axios.post<createCorporateUserRequest>("/api/corporation/user/attestation", req, {
    headers: {
      "Content-Type": "application/json;charset=utf-8",
    },
  });
};

/**
 * プロジェクト作成
 */
export const createCorporateProject = async (
  req: createCorporateProjectRequest
): Promise<void> => {
  const data = toFormData(req as unknown as Record<string, unknown>);
  await axios.post<createCorporateUserRequest>("/api/corporateProject", data, {
    headers: { "Content-Type": "multipart/form-data", },
  });
};

/**
 * プロジェクト更新
 */
export const updateCorporateProject = async (
  req: updateCorporateProjectRequest
): Promise<void> => {
  const data = toFormData(req as unknown as Record<string, unknown>);
  await axios.post<updateCorporateProjectRequest>(`/api/corporateProject/update?id=${req.id}`, data, {
    headers: { "Content-Type": "multipart/form-data", },
  });
};

// {} をFormDataに変換する
const toFormData = (req: Record<string, unknown>): FormData => {
  const data = new FormData();
  for (const [k, v] of Object.entries(req)) {
    if (v === null) {
      continue;
    }
    if (v instanceof Blob) {
      data.set(k, v);
    } else if (typeof v !== "object") {
      data.set(k, `${v}`);
    } else {
      // NOTE: FormData の値は string | Blob なので object は stringify() する
      data.set(k, JSON.stringify(v));
    }
  }
  return data;
};

/**
 * プロジェクト一覧取得
 */
export const getProjects = async (): Promise<Project[]> => {
  const res = await axios.get<Project[]>(`/api/corporateProjects`);
  return res.data;
};

/**
 * プロジェクト一覧取得（ユーザー）
 */
export const getUserProjects = async (): Promise<Project[]> => {
  const res = await axios.get<Project[]>(`/api/corporateProjects/user`);
  return res.data;
};

/**
 * プロジェクト取得
 */
export const getProject = async (id: string): Promise<Project> => {
  const res = await axios.get<Project>(`/api/corporateProject?id=${id}`);
  return res.data;
};

/**
 * プロジェクト削除
 */
export const deleteProject = async (id: string): Promise<void> => {
  await axios.delete<void>(`/api/corporateProject?id=${id}`);
};

/**
 * 承諾待ちレビュー一覧取得
 */
export const getCorporatePendingDeals = async (): Promise<EmployeeDealsResponse[]> => {
  const res = await axios.get<EmployeeDealsResponse[]>(`/api/corporation/deal/list`);
  return res.data;
};

/**
 * 法人削除
 */
export const deleteCorporate = async (): Promise<void> => {
  await axios.delete<void>(`/api/corporation`)
}
/**

* 請求明細一覧を取得する
 */
export const getCorporatebillingDeals = async (): Promise<billingStatementResponse[]> => {
  const res = await axios.get<billingStatementResponse[]>(`/api/corporation/billing/list`);
  return res.data;
};

/**
 * 決済情報を登録する
 */
export const createPaymentInfomationCorporation = async(req: CreatePaymentInformationCorporateRequest): Promise<void> => {
  const res = await axios.post(
    `/api/corporation/card`,
    req,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return res.data;
}

/**
 * 決済情報を削除する
 */
export const deletePaymentInformationCorporation = async (): Promise<void> => {
  await axios.delete<void>(`/api/corporation/card`);
}